module.exports = __webpack_public_path__ + "static/design-0f5e4461123927e34f4c6bf39ac59cb5.jpeg";